import debounce from 'lodash/debounce'
import React from 'react'

export const BOTTOM_BAR_HEIGHT = 54
export const getTopbarHeight = (width: number) => (width < 600 ? 68 : 73)
export const useDimensions = () => {
  const [width, setWidth] = React.useState<number>(window.innerWidth)
  const [height, setHeight] = React.useState<number>(window.innerHeight)

  const setDimensions = () => {
    if (window) {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }
  }

  const throttle = debounce(() => setDimensions(), 0)

  React.useEffect(() => {
    window.addEventListener('resize', () => throttle())
    setDimensions()
  }, [throttle])

  return { width, height: height - BOTTOM_BAR_HEIGHT }
}
